'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useState } from 'react';
import Button from '../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../HOC/Modal';
type Props = {
  closeHandler: () => void;
  enable2FAHandler: (skipCurrentSession: boolean) => void;
};
const TwoFAInfo = t0 => {
  const $ = _c(52);
  const {
    closeHandler
  } = t0;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [clearSessions, setClearSessions] = useState(true);
  const cards = _temp;
  let t1;
  if ($[0] !== currentIndex) {
    t1 = type => {
      if (type === "back" && currentIndex !== 0) {
        setCurrentIndex(_temp2);
      } else {
        if (type === "next" && currentIndex != cards().length - 1) {
          setCurrentIndex(_temp3);
        }
      }
    };
    $[0] = currentIndex;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleCard = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2>Enable 2FA</h2>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== closeHandler) {
    t3 = <ModalHeader closeHandler={closeHandler}>{t2}</ModalHeader>;
    $[3] = closeHandler;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== toggleCard) {
    t4 = () => toggleCard("back");
    $[5] = toggleCard;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ArrowLeft className="ml-2" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <button className="size-8 rounded-full border-none bg-background-secondary outline-none" title="back button" onClick={t4}>{t5}</button>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = currentIndex + 1;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cards();
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = t8[currentIndex];
  let t10;
  if ($[11] !== t7 || $[12] !== t9.title) {
    t10 = <p className="mb-2 text-center text-base font-semibold">#{t7} {t9.title}</p>;
    $[11] = t7;
    $[12] = t9.title;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = cards();
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = t11[currentIndex];
  let t13;
  if ($[15] !== t12.description) {
    t13 = <p className="mx-auto w-96 text-center text-textSecondary">{t12.description}</p>;
    $[15] = t12.description;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t10 || $[18] !== t13) {
    t14 = <div className="flex w-96 flex-col justify-items-center">{t10}{t13}</div>;
    $[17] = t10;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== toggleCard) {
    t15 = () => toggleCard("next");
    $[20] = toggleCard;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <ArrowRight className="ml-2" />;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t15) {
    t17 = <button className="size-8 rounded-full border-none bg-background-secondary outline-none" title="next button" onClick={t15}>{t16}</button>;
    $[23] = t15;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t14 || $[26] !== t17 || $[27] !== t6) {
    t18 = <div className="mb-3 flex h-52 items-center justify-between rounded-md p-2 shadow-inner shadow-neutral-500">{t6}{t14}{t17}</div>;
    $[25] = t14;
    $[26] = t17;
    $[27] = t6;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setClearSessions(_temp4);
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== clearSessions) {
    t20 = <input className="size-3.5 cursor-pointer" id="sessionsClearCheckbox" type="checkbox" checked={clearSessions} onChange={t19} />;
    $[30] = clearSessions;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <label className="ml-2 cursor-pointer select-none" htmlFor="sessionsClearCheckbox">Clear all my previously active sessions (except this one)</label>;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t20) {
    t22 = <div className="my-4 flex items-center justify-start p-2 text-textSecondary">{t20}{t21}</div>;
    $[33] = t20;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== t18 || $[36] !== t22) {
    t23 = <ModalContent>{t18}{t22}</ModalContent>;
    $[35] = t18;
    $[36] = t22;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== closeHandler) {
    t24 = <Button text="Cancel" variant="SECONDARY" onClick={closeHandler} borderTransparent={false} />;
    $[38] = closeHandler;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = cards();
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  const t26 = currentIndex !== t25.length - 1;
  let t27;
  if ($[41] !== closeHandler || $[42] !== t26) {
    t27 = <Button text="Got it" onClick={closeHandler} disabled={t26} />;
    $[41] = closeHandler;
    $[42] = t26;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== t24 || $[45] !== t27) {
    t28 = <ModalFooter>{t24}{t27}</ModalFooter>;
    $[44] = t24;
    $[45] = t27;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== closeHandler || $[48] !== t23 || $[49] !== t28 || $[50] !== t3) {
    t29 = <Modal closeHandler={closeHandler}>{t3}{t23}{t28}</Modal>;
    $[47] = closeHandler;
    $[48] = t23;
    $[49] = t28;
    $[50] = t3;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  return t29;
};
export default TwoFAInfo;
function _temp() {
  return [{
    title: "2FA can only be enabled from the mobile app",
    description: "To enable 2FA on your account, you must be logged in to the Factiii mobile app. 2FA cannot be enabled from the web interface."
  }, {
    title: "How to enable 2FA",
    description: "1. Open the Factiii mobile app and log in to your account. 2. Go to Settings > Security. 3. Tap \"Enable 2FA\" and follow the instructions."
  }, {
    title: "What is 2FA?",
    description: "By activating 2FA, you'll get a unique code on the Factiii mobile app when you try to login to your account from a new device. This adds an extra layer of security."
  }, {
    title: "All devices will be automatically enrolled in 2FA and can login without a code",
    description: "You can manage your devices from the \"Security\" section in your account settings. We suggest removing old devices for maximum security."
  }, {
    title: "What if I lose access to my phone?",
    description: "If you lose your phone, you can use your email to receive a one-time password (OTP) for account access."
  }];
}
function _temp2(x) {
  return x - 1;
}
function _temp3(x_0) {
  return x_0 + 1;
}
function _temp4(x_1) {
  return !x_1;
}